import React from 'react';
import { List } from 'immutable';
import UserSoundItem from 'flow/components/custom-components/UserSoundItem';
import SettingSection from 'flow/components/Setting/SettingSection';
import Divider from 'flow/components/ui-components/Divider';
import { Sound } from 'flow/types/Sound';
import { TypedMap } from 'flow/types/TypedMap';
import { StandardVoicemailSound } from 'flow/types/VoicemailSettings';
import { homeActionUrlPath } from 'flow/utils';

type Props = {
    handleClick: (userSoundKey: string) => void;
    privateUserSoundList: List<TypedMap<Sound>>;
    standardSoundDTO: TypedMap<StandardVoicemailSound>;
    ownRecordingFile: TypedMap<Sound>;
    selectedSoundKey: string;
    subheader: string;
};

const VoicemailSettingsPlaybackPicker = ({
    handleClick,
    privateUserSoundList,
    selectedSoundKey,
    standardSoundDTO,
    ownRecordingFile,
    subheader,
}: Props) => {
    return (
        <>
            <SettingSection>{subheader}</SettingSection>
            <Divider />

            <UserSoundItem
                key={'voicemail-sound' + standardSoundDTO.get('key')}
                usersoundKey={standardSoundDTO.get('key')}
                displayedText={standardSoundDTO.get('name')}
                playbackUrl={homeActionUrlPath(
                    `/${standardSoundDTO.get('playbackURL')}`,
                )}
                handleClick={handleClick}
                selectedSoundKey={selectedSoundKey}
            />

            {ownRecordingFile ? (
                <UserSoundItem
                    key={'voicemail-sound' + ownRecordingFile.get('key')}
                    usersoundKey={ownRecordingFile.get('key')}
                    displayedText={ownRecordingFile.get('name')}
                    playbackUrl={homeActionUrlPath(
                        '/' + ownRecordingFile.get('playbackURL'),
                    )}
                    handleClick={handleClick}
                    selectedSoundKey={selectedSoundKey}
                />
            ) : null}

            {privateUserSoundList.map((soundDTO) => (
                <UserSoundItem
                    key={'voicemail-sound' + soundDTO.get('key')}
                    usersoundKey={soundDTO.get('key')}
                    displayedText={soundDTO.get('name')}
                    playbackUrl={homeActionUrlPath(
                        '/' + soundDTO.get('playbackURL'),
                    )}
                    handleClick={handleClick}
                    selectedSoundKey={selectedSoundKey}
                />
            ))}
        </>
    );
};

export default VoicemailSettingsPlaybackPicker;
